import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { IBg } from '~/src/features/center/utils';

import { Form } from '~/src/features/center/Form/styled';
import { Offer } from '~/src/features/center/Offer/styled';

const thumbColor = '#d3d3d3';

export const PriceBlockContainer = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 32px;
    overflow-y: scroll;
    //For Mozilla
    scrollbar-width: none;

    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
        margin-top: 27px;
        margin-bottom: 27px;
    }

    ::-webkit-scrollbar-corner {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: ${thumbColor};
    }
`;

export const Text = styled.div`
    ${FONTS.M};
    margin: 4px 0;
    opacity: .8;

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    position: relative;
    flex-direction: column;
    border-radius: 32px;
    padding: 40px 40px 26px 40px;
    background: radial-gradient(${(props: IBg) => props.bgGradientPrice}), ${COLORS.white};

    @media (max-width: 350px) {
        padding: 40px 25px 26px 25px;
    }
`;

export const Title = styled.div`
    ${FONTS.H3};
    margin-top: 8px;
    margin-bottom: 4px;

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H4};
    }
`;

export const RadioWrapper = styled.div`
    display: block;
    width: 100%;
    margin-bottom: 20px;
`;

export const BottomWrapper = styled.div`
    flex-grow: 1;

    & ${Form} {
        height: auto;
        width: auto;
        justify-content: left;

        @media (max-width: ${breakPoints.tablet}) {
            width: 100%;
        }

        @media (max-width: ${breakPoints.mobile}) {
            justify-content: center;
        }
    }

    & ${Form} p {
        display: none;
    }
`;

export const OfferWrapper = styled.div`
    width: 100%;

    & ${Offer} {
        white-space: normal;

        @media (max-width: ${breakPoints.mobile}) {
            ${FONTS.XXS};
        }
    }
`;

export const BottomContainer = styled.div`
    margin-top: auto;

    & ${Form} {
        @media (max-width: ${breakPoints.desktop}) and (min-width: 1278px) {
            width: 100%;
        }
    }
`;

export const BottomBlock = styled.p`
    padding-right: 40px;
    ${FONTS.XS};
    opacity: .8;
    margin-top: 12px;

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XXS};
        padding-right: 0;
    }
`;
